/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Switch_4Inputs */

const en_fc_vs_switch_4 = /** @type {(inputs: Fc_Vs_Switch_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Premiere editing shortcuts mostly work the same way. Remap the rest in the shortcut editor.`)
};

/**
* | output |
* | --- |
* | "Your Premiere editing shortcuts mostly work the same way. Remap the rest in the shortcut editor." |
*
* @param {Fc_Vs_Switch_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_switch_4 = /** @type {((inputs?: Fc_Vs_Switch_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Switch_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_switch_4(inputs)
});
export { fc_vs_switch_4 as "fc.vs.switch.4" }